import App from "./components/App.jsx";
import {initializeDialogueTheme} from "../../../../../shared/js";

// noinspection JSIgnoredPromiseFromCall
initializeDialogueTheme({
    ThemeComponent: App
});
